export const TEXT = "Text";
export const NUMBER = "Number";
export const DATE = "Date";
export const BUTTON = "Button";
export const UPLOAD = "Upload";
export const CHECKBOX = "Checkbox";
export const CHECKBOXLIST = "CheckBoxList";
export const OPTIONLIST = "OptionList";
export const LINKEDLIST = "LinkedList";
export const DYNAMICTABLE = "DynamicTable";
export const GRID = "Grid";
export const STEPPER = "Etapa";
export const HTML = "Html";
export const TYPOGRAPHY = "Typography";
export const IMAGE = "Image";
export const ECMDOCUMENTS = "ECMdocuments";
export const UPLOADDOCUMENT = "Documento";
export const MINUTE = "Minuta";
export const CNPJ = "CNPJ";
export const CPF = "CPF";
export const DYNAMICLIST = "DynamicList";
export const MULTDOCSUPLOAD = "MultDocsUpload";
export const DOCUMENTVIEWER = "DocumentViewer";
export const MULTIPLEUPLOADREQUIRED = "MultipleUploadRequired";
